import React, { useState } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Modal,
  Button,
  ParagraphText,
  FormField,
  TextInput,
  InputStatusMessage,
} from '@leagueplatform/genesis-core';

import { isEmpty, isValidateEmail } from '../../utils/index';
import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';

export function EmailAddressModal(props: any) {
  const {
    open,
    heading,
    cancelBtn,
    saveBtn,
    onClose,
    description,
    email,
    setEmail,
    updateEmailAddress,
    updateContactLoading,
  } = props;

  const [emailError, setEmailError] = useState<string>('');

  const updateErrorState = () => {
    if (isEmpty(email) || !isValidateEmail(email)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  const handleConfirmation = () => {
    updateErrorState();
    if (emailError === '' && isValidateEmail(email)) {
      // onClose();
      updateEmailAddress();
    }
  };

  const onUpdateField = (event: any) => {
    const { value } = event.target;
    setEmail(value);
  };

  const onBlurField = () => {
    updateErrorState();
  };

  const onKeyPressField = () => {
    updateErrorState();
  };

  return (
    <Box>
      <Modal.Root open={open}>
        <Modal.Content
          data-testid="email-modal"
          showCloseButton={false}
          css={
            {
              borderRadius: 'initial',
              background: '#fff',
              padding: '20px 30px',
              '.GDS-modal': {
                borderRadius: '$none',
                // },
                // '.GDS-c-bVpebC-igUcHly-css': {
                margin: '0px',
                // height: ['Firefox'].includes(browser) ? '100vh' : '',
                // maxHeight: ['Firefox'].includes(browser) ? '720px' : 'initial',
              },
            } as GDSStyleObject
          }
          width={{
            '@initial': 'standard',
            '@laptop': '38%',
            '@mobileLandscape': '50%',
            '@tablet': '50%',
          }}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <StackLayout
            css={{
              textAlign: 'center',
              alignItems: 'center',
              opacity: updateContactLoading ? 0.1 : 'initial',
            }}
          >
            <Box
              css={
                {
                  margin: '$one',
                  backgroundColor: 'White',
                } as GDSStyleObject
              }
            >
              <img
                style={{ cursor: 'pointer' }}
                src={
                  useStaticAsset(
                    SHARED_LIBRARY_ASSET_KEYS.FAILURE_ICON,
                  ) as string
                }
                alt="right arrow icon"
                width="45px"
              />
              <HeadingText
                data-testid="email-heading"
                level="3"
                size="sm"
                css={
                  {
                    paddingTop: '$one',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '32px',
                    fontSize: 24,
                    color: '#2C3135',
                  } as GDSStyleObject
                }
              >
                {heading}
              </HeadingText>
              <ParagraphText
                data-testid="email-description"
                css={
                  {
                    margin: '$two $none $one $none',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '24px',
                    fontSize: 16,
                    color: '#2C3135',
                  } as GDSStyleObject
                }
              >
                {description}
              </ParagraphText>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                  } as GDSStyleObject
                }
              >
                <FormField
                  data-testid="email-input"
                  id="EmailAddress"
                  label="Email Address"
                  css={
                    {
                      padding: '0px 15px $one 15px',
                    } as GDSStyleObject
                  }
                  inputStatus={emailError ? 'error' : undefined}
                  statusIconLabel={emailError ? 'Error' : ''}
                  statusMessage={
                    <InputStatusMessage hideIcon data-testid="error-message">
                      {emailError}
                    </InputStatusMessage>
                  }
                >
                  <TextInput
                    name="emailAddress"
                    id="emailAddress"
                    placeholder="Email Address"
                    onChange={onUpdateField}
                    value={email}
                    onBlur={onBlurField}
                    onKeyUp={onKeyPressField}
                  />
                </FormField>
              </Box>

              <StackLayout
                horizontalAlignment="start"
                css={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Button
                  data-testid="cancel-btn"
                  size="small"
                  css={
                    {
                      color: '#0074C9',
                      cursor: 'pointer',
                      fontWeight: '700',
                      fontSize: 16,
                      padding: '$one',
                      background: 'none',
                      '&:hover,&:active,&:focus': {
                        background: 'none',
                      },
                    } as GDSStyleObject
                  }
                  onClick={onClose}
                >
                  {cancelBtn}
                </Button>

                <Button
                  data-testid="save-btn"
                  size="small"
                  css={
                    {
                      color: '#0074C9',
                      cursor: 'pointer',
                      fontWeight: '700',
                      fontSize: 16,
                      padding: '$one',
                      background: 'none',
                      '&:hover,&:active,&:focus': {
                        background: 'none',
                      },
                    } as GDSStyleObject
                  }
                  onClick={handleConfirmation}
                >
                  {saveBtn}
                </Button>
              </StackLayout>
            </Box>
          </StackLayout>
          {updateContactLoading && <LoadingIndicator />}
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
